import template from './employee_view_disciplinary_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewDisciplinaryComponentViewModel
{
    constructor(bindings)
    {
        this.bindings = bindings;
        this.employee
        this.employee_id = ko.observable();
        this.valid_date = ko.observable();
        this.employee = ko.observable(null);
        this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
        this.employee_disciplinary = ko.observableArray([]);
        this.employee_warnings = ko.observableArray([]);
        this.document_types = ko.observableArray();
        this.access_roles = ko.observableArray();

        if (bindings.employee && ko.isObservable(bindings.employee))
        {
            bindings.employee.subscribe((nv) => {
                if (nv) {
                    this.employee(nv);
                    this.updateData();
                }
            });
        }

        if (bindings.employee_id && ko.isObservable(bindings.employee_id)) 
            bindings.employee_id.subscribe((nv) => this.employee_id(nv));

    }

    async updateData()
    {
        await this.load_page();
    }

    async load_page()
    {
        this.employee_id(this.employee().employee_id);
        //dummy data for demo purpose Only
        this.employee_warnings([
            { name: "Written 1st warning for employee", note: "First written warning", type: "Personal info", status: "Approved", valid_date: "2025-02-28", filename_link: "#", access_rights: "admin, manager"},
            { name: "Written 2nd warning for employee", note: "Second written warning", type: "Personal info", status: "In progress", valid_date: "2025-03-31", filename_link: "#", access_rights: "admin, manager"}
        ]);

        this.employee_disciplinary([
            { name: 'Attendance Letter 2024-12-05', note: 'Have not been attending lately. ', type: 'Personal Info', filename_link: '#', status: "Completed", valid_date: "2024-12-30", access_rights: "admin, manager, general_manager" },
            { name: 'Disciplinary Letter 2025-01-15', note: 'Bad behavior', type: 'Personal Info', filename_link: '#', status: "Approved", valid_date: "2024-03-31", access_rights: "admin, manager, general_manager" }
        ]);
        //}
    }

    async btn_add_warning(header)
    {
        await Grape.dialog.open('EmployeeAddDisciplinary', { employee_id: this.employee_id(), title: header });
        this.updateData();
    }


    async add_document(v, e)
    {
        let data = ko.toJS(v);
        await Grape.dialog.open('EmployeeUploadDocument', { employee_id: this.employee_id(), employee_document_type_id: data.employee_document_type_id });
        this.updateData();
    }

    download_(v, e)
    {
        let data = ko.toJS(v);
        window.open(data.filename_link + '?download=yes', '_blank');
    }

    view_document(v, e)
    {
        let data = ko.toJS(v);
        window.open(data.filename_link, '_blank');
    }
}

export default {
    name: 'employee_view_disciplinary_component',
    viewModel: EmployeeViewDisciplinaryComponentViewModel,
    module_type: 'ko',
    template: template,
    template_filename: 'translation/components/employee_view_disciplinary_component'
};